import * as React from "react"
import { Typography } from "~/components/ui/typography"
import { cn } from "~/utils/style"

const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-md border bg-card text-card-foreground shadow-xs",
      className,
    )}
    {...props}
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-6", className)}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

type HeadingsElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6"

type CardTitleProps = {
  className?: string
  as?: HeadingsElement
}

const defaultCardTitleElement = "h3"

const CardTitle = ({
  className,
  children,
  as = defaultCardTitleElement,
}: React.PropsWithChildren<CardTitleProps>) => {
  return (
    <Typography
      variant="h2"
      as={as}
      fontWeight="semibold"
      className={className}
    >
      {children}
    </Typography>
  )
}
CardTitle.displayName = "CardTitle"

type CardDescriptionProps = {
  className?: string
}

const CardDescription = ({
  className,
  children,
}: React.PropsWithChildren<CardDescriptionProps>) => (
  <Typography variant="muted" className={className}>
    {children}
  </Typography>
)
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-6 pt-0", className)}
    {...props}
  />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
